import { loadable } from '../../../components/loadable';

export const LoadableCourseAdmin = loadable(() => import('./connector'), {
  /* webpackChunkName: 'CourseAdmin' */ key: 'ConnectedCourseAdmin',
});
